import { type Ref } from 'vue'
import { darkTheme, useOsTheme, type GlobalComponentConfig, type GlobalTheme, type GlobalThemeOverrides } from "naive-ui";
import { defineStore } from "pinia";

interface ThemeStore {
  theme: Ref<GlobalTheme | null>
  localSetting: Ref<string | null>
  themeOverrides: Ref<Partial<GlobalThemeOverrides>>
  componentOptions: Ref<GlobalComponentConfig>
  apply: Function
  set: Function
}

type ThemeOption = 'light' | 'dark' | null

const commonOverrides = {
  fontWeightStrong: '600',
  primaryColor: '#0EB1D2',
}

const lightThemeOverrides: GlobalThemeOverrides = {
  common: {
    ...commonOverrides,
    bodyColor: '#fcfcfcff',
    tagColor: '#fff'
  }
}

const darkThemeOverrides: GlobalThemeOverrides = {
  common: {
    ...commonOverrides,
    bodyColor: '#22242f',
    cardColor: '#292b35',
    // primaryColor: '#449DD1'
    // primaryColor: '#0EB1D2',
    tagColor: 'rgba(255,255,255,0.1)'
  }
}

export const useThemeStore = defineStore('theme', () => {
  const osTheme = useOsTheme()
  const theme = ref<GlobalTheme | null>(null)
  const localSetting = ref<string | null>(localStorage.getItem('theme'))
  const themeOverrides = computed(() => theme.value ? darkThemeOverrides : lightThemeOverrides)
  const componentOptions = ref<GlobalComponentConfig>({
    Button: {
      size: 'small'
    },
    Card: {
      size: 'small'
    },
    Tag: {
      size: 'small'
    },
  })

  function apply() {
    // Check if there is a setting in localStorage
    const savedSetting = localSetting.value ?? osTheme.value
  
    theme.value = savedSetting === 'dark' ? darkTheme : null
  }

  function set(value: ThemeOption): void {
    localSetting.value = value

    if (value) {
      localStorage.setItem('theme', value)
    }
    else {
      localStorage.removeItem('theme')
    }

    apply()
  }

  const returnObject: ThemeStore = { theme, localSetting, themeOverrides, componentOptions, apply, set }

  apply()
  return returnObject
})